import React, { createContext, useContext } from "react";

export type SessionStatus = "restoring" | "ready";

const SessionContext = createContext<SessionStatus>("ready");

export function SessionProvider({
  status,
  children,
}: {
  status: SessionStatus;
  children: React.ReactNode;
}) {
  return <SessionContext.Provider value={status}>{children}</SessionContext.Provider>;
}

export function useSessionStatus() {
  return useContext(SessionContext);
}
